/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSectorQueryResult } from '../../models/get-sector-query-result';

export interface ApiSectorGetSectorGet$Plain$Params {
  Id?: string;
}

export function apiSectorGetSectorGet$Plain(http: HttpClient, rootUrl: string, params?: ApiSectorGetSectorGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSectorQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiSectorGetSectorGet$Plain.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSectorQueryResult>;
    })
  );
}

apiSectorGetSectorGet$Plain.PATH = '/api/Sector/GetSector';
